import { asyncRouterMap, constantRouterMap } from "@/router";
import Layout from "@/views/layout/Layout";

const permission = {
  state: {
    routers: [],
    addRouters: [],
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
    },
  },
  actions: {
    GenerateRoutes ({ commit }) {
      return new Promise((resolve) => {
        let accessedRouters = asyncRouterMap.concat(loadRouter());

        console.log('accessedRouters', accessedRouters)

        commit("SET_ROUTERS", accessedRouters);
        resolve(accessedRouters);
      });
    }
  },
};

function loadRouter () {
  const user = JSON.parse(localStorage.getItem('userInfo'))
  let newList = [];
  user.menus.forEach(el => {
    let { path, name, id, iconUrl, childMenu } = el

    if(path === "sportManage") {
      el.path = '/sportManage'
      path = '/sportManage'
    }

    if (childMenu && childMenu.length > 0) {
      childMenu = childMenu.map(item => {
        let { path, id, name } = item;
        // console.log(`=====>/views${el.path}/${path}/index`)

        return {
          path: path,
          name: path,
          id: id,
          component: (resolve) => require([`@/views${el.path}/${path}/index`], resolve),
          meta: {
            title: name,
            icon: iconUrl,
            noCache: true,
            jumpPath: `/${path}`
          },
        }
      })
    }

    let router = {
      path: path,
      id: id,
      name: name,
      icon: iconUrl,
      replace: `${path}/${childMenu ? childMenu[0] && childMenu[0].path : ''}`,
      component: Layout,
      children: childMenu
    }
    
    newList.push(router)
  });
  
  // console.log('newList', newList)
  return newList
}

export default permission;
